import {
  CONTENTFUL_ACCESS_TOKEN,
  CONTENTFUL_SPACE,
  CONTENTFUL_GRAPQL,
} from '@/constants/env';
import { GraphQLClient as Client } from 'graphql-request';
import { createClient } from 'contentful';

let contentfulClient: ReturnType<typeof createClient> | undefined;
export function getContentful() {
  if (typeof contentfulClient === 'undefined') {
    contentfulClient = createClient({
      space: CONTENTFUL_SPACE,
      accessToken: CONTENTFUL_ACCESS_TOKEN,
    });
  }
  return contentfulClient;
}

export function contentfulQuery<T, V = any>(
  query: string,
  variables?: V
): Promise<T> {
  return GraphQLClient.getContentfulClient().request<T, V>(query, variables);
}

class GraphQLClient {
  private static contentfulClient: Client;

  static getContentfulClient(): Client {
    if (!this.contentfulClient) {
      const CONTENTFUL_GRAPHQL_URL = `${
        CONTENTFUL_GRAPQL || 'https://graphql.contentful.com/content/v1/spaces/'
      }${CONTENTFUL_SPACE}`;
      this.contentfulClient = new Client(CONTENTFUL_GRAPHQL_URL, {
        headers: {
          Authorization: `Bearer ${CONTENTFUL_ACCESS_TOKEN}`,
        },
      });
    }

    return this.contentfulClient;
  }
}
